"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppleAuthenticationResponseDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const Account_dto_1 = require("./Account.dto");
const UserMinimal_dto_1 = require("./UserMinimal.dto");
class AppleAuthenticationResponseDto {}
exports.AppleAuthenticationResponseDto = AppleAuthenticationResponseDto;
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.AppleAuthenticationFlow
}), __metadata("design:type", String)], AppleAuthenticationResponseDto.prototype, "flow", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'True when profile and photo registration must be completed before a system JWT is issued.'
}), __metadata("design:type", Boolean)], AppleAuthenticationResponseDto.prototype, "registrationRequired", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'System JWT. Present only when flow is Login.'
}), __metadata("design:type", String)], AppleAuthenticationResponseDto.prototype, "token", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], AppleAuthenticationResponseDto.prototype, "grantedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false
}), __metadata("design:type", String)], AppleAuthenticationResponseDto.prototype, "expiresAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'Registration session UUID. Present only when flow is Registration.'
}), __metadata("design:type", String)], AppleAuthenticationResponseDto.prototype, "registrationUuid", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => Account_dto_1.AccountDto
}), __metadata("design:type", Account_dto_1.AccountDto)], AppleAuthenticationResponseDto.prototype, "account", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => UserMinimal_dto_1.UserMinimalDto,
  nullable: true
}), __metadata("design:type", Object)], AppleAuthenticationResponseDto.prototype, "user", void 0);
//# sourceMappingURL=AppleAuthenticationResponse.dto.js.map